/* eslint-disable no-unused-vars */

import { iseeInstance } from '../axiosService'

class HomeVUService {
  async fetchSummaryAnalytics (portalName, userId) {
    return iseeInstance.get(
      `/sessions/analytics/summary/${portalName}${
        userId ? '?userId=' + userId : ''
      }`
    )
  }

  async fetchFiles (portalName, { page = 1, limit = 10 } = {}) {
    const params = new URLSearchParams()
    params.set('page', page)
    params.set('limit', limit)
    return iseeInstance.get(`/files/list/${portalName}?${params.toString()}`)
  }

  async viewFile (portalName, fileKey) {
    return iseeInstance.post('/files/view', {
      portal: portalName,
      key: fileKey
    })
  }

  async viewFileById (portalName, fileId) {
    return iseeInstance.post('/files/view/' + fileId, {
      portal: portalName
    })
  }

  async fetchDevices (portalName) {
    return iseeInstance.get(`/devices/portal/${portalName}`)
  }

  async fetchUsers (portalName) {
    return iseeInstance.get(`/users/portal/${portalName}`)
  }

  async fetchScreens (portalName) {
    return iseeInstance.get(`/screens/${portalName}`)
  }

  async createScheduledMeeting (params) {
    return iseeInstance.post('/scheduledMeetings/', params)
  }

  async deleteScheduledMeeting (id) {
    return iseeInstance.delete(`/scheduledMeetings/${id}`)
  }

  async editScheduledMeeting (id, params) {
    return iseeInstance.put(`/scheduledMeetings/${id}`, params)
  }

  async getScheduledMeeting (id) {
    return iseeInstance.get(`/scheduledMeetings/${id}`)
  }

  async getScheduledMeetings (portalName, id, { userId, startDate, endDate, page = 1, limit = 10, timeFilter } = {}) {
    const params = new URLSearchParams()
    if (userId) params.set('userId', userId)
    if (startDate) params.set('startDate', startDate)
    if (endDate) params.set('endDate', endDate)
    if (timeFilter) params.set('timeFilter', timeFilter)
    params.set('page', page)
    params.set('limit', limit)
    return iseeInstance.get(
      `/scheduledMeetings/${portalName}/${id}?${params.toString()}`
    )
  }

  async getTips (portalName, isActive) {
    return iseeInstance.get(
      `/tips/${portalName}${
        isActive !== undefined ? '?isActive=' + isActive : ''
      }`
    )
  }

  async linkCall (sessionId, meetingId) {
    return iseeInstance.post('/sessions/link-session', {
      sessionId,
      meetingId
    })
  }

  async getProviderAvailability (portalName) {
    return iseeInstance.get(`/providerAvailability/${portalName}`)
  }

  async getProviderAvailabilityByUser (portalName, userId) {
    return iseeInstance.get(`/providerAvailability/${portalName}/${userId}`)
  }

  async saveProviderAvailability (params) {
    return iseeInstance.put('/providerAvailability', params)
  }

  async deleteProviderAvailability (portalName, userId) {
    return iseeInstance.delete(`/providerAvailability/${portalName}/${userId}`)
  }
}

export default new HomeVUService()
